import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slice/authSlice";
import authApi from "./services/authServices";
import mealService from "./services/mealService";
import emailService from "./services/EmailTemplateService";
import dietService from "./services/dietService";
import ingredientService from "./services/ingredientService";
import settingsService from "./services/settingsService";
import userService from "./services/userService";
import contactUsService from "./services/contactUsService";
import orderService from "./services/orderService";
import contentPagesServices from "./services/contentPagesServices";
import FAQServices from "./services/FAQServices";
import recipeService from "./services/recipeService";
import blogServices from "./services/blogServices";
import HomePageContentService from "./services/HomePageContentService";
import promoCodeService from "./services/promoCodeService";
import equipmentService from "./services/equipmentService";
import AboutAndSustainabilityContentService from "./services/AboutAndSustainabilityContentService";
import FaqPageContentService from "./services/FaqPageContentService";
import ContactUsContentService from "./services/ContactUsContentService";
import PartnershipContentService from "./services/PartnershipContentService";
import orderSingleService from "./services/orderSingleService";
import refundService from "./services/refundService";
import categoryService from "./services/categoryService";
import reviewService from "./services/reviewService";
import productStore from "./services/ProductStore";
import productBannerApi from "./services/ProductBanner";
import dietaryPreferencesService from "./services/DietaryPreferences";
import deliveryInformationService from "./services/DeliveryInformation";
import ratings from "./services/ratings";
// Configure persist for auth reducer
const persistConfig = {
  key: "auth",
  storage,
};
const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    [authApi.reducerPath]: authApi.reducer,
    [mealService.reducerPath]: mealService.reducer,
    [categoryService.reducerPath]: categoryService.reducer,
    [refundService.reducerPath]: refundService.reducer,
    [emailService.reducerPath]: emailService.reducer,
    [reviewService.reducerPath]: reviewService.reducer,
    [dietService.reducerPath]: dietService.reducer,
    [ingredientService.reducerPath]: ingredientService.reducer,
    [settingsService.reducerPath]: settingsService.reducer,
    [userService.reducerPath]: userService.reducer,
    [contactUsService.reducerPath]: contactUsService.reducer,
    [orderService.reducerPath]: orderService.reducer,
    [orderSingleService.reducerPath]: orderSingleService.reducer,
    [contentPagesServices.reducerPath]: contentPagesServices.reducer,
    [FAQServices.reducerPath]: FAQServices.reducer,
    [recipeService.reducerPath]: recipeService.reducer,
    [blogServices.reducerPath]: blogServices.reducer,
    [HomePageContentService.reducerPath]: HomePageContentService.reducer,
    [FaqPageContentService.reducerPath]: FaqPageContentService.reducer,
    [ContactUsContentService.reducerPath]: ContactUsContentService.reducer,
    [promoCodeService.reducerPath]: promoCodeService.reducer,
    [equipmentService.reducerPath]: equipmentService.reducer,
    [PartnershipContentService.reducerPath]: PartnershipContentService.reducer,
    [AboutAndSustainabilityContentService.reducerPath]:
      AboutAndSustainabilityContentService.reducer,
    [productStore.reducerPath]: productStore.reducer,
    [dietaryPreferencesService.reducerPath]: dietaryPreferencesService.reducer,
    [productBannerApi.reducerPath]: productBannerApi.reducer,
    [ratings.reducerPath]: ratings.reducer,
    [deliveryInformationService.reducerPath]:
      deliveryInformationService.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      authApi.middleware,
      mealService.middleware,
      categoryService.middleware,
      refundService.middleware,
      emailService.middleware,
      dietService.middleware,
      ingredientService.middleware,
      settingsService.middleware,
      userService.middleware,
      contactUsService.middleware,
      orderService.middleware,
      orderSingleService.middleware,
      contentPagesServices.middleware,
      FAQServices.middleware,
      recipeService.middleware,
      blogServices.middleware,
      HomePageContentService.middleware,
      FaqPageContentService.middleware,
      ContactUsContentService.middleware,
      promoCodeService.middleware,
      equipmentService.middleware,
      AboutAndSustainabilityContentService.middleware,
      PartnershipContentService.middleware,
      reviewService.middleware,
      productStore.middleware,
      productBannerApi.middleware,
      dietaryPreferencesService.middleware,
      deliveryInformationService.middleware,
      ratings.middleware
    ),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
